export { default } from './NegativateDetail'
export * as S from './NegativateDetail.styles'
